import * as React from "react";
const SvgFiRrHandHoldingDroplet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-holding-droplet_svg__a)">
      <path
        fill="#062147"
        d="M9 8.96c2.206 0 4-1.742 4-3.884 0-1.163-.73-2.59-2.17-4.241-.924-1.062-2.736-1.062-3.659 0C5.731 2.487 5 3.914 5 5.077 5 7.219 6.794 8.96 9 8.96zm-.321-6.812A.42.42 0 0 1 9 2a.42.42 0 0 1 .321.148C10.372 3.354 11 4.449 11 5.077c0 1.039-.897 1.884-2 1.884s-2-.845-2-1.884c0-.628.627-1.723 1.679-2.93m14.338 6.638a3 3 0 0 0-2.168-.782 3 3 0 0 0-2.086.98l-3.216 3.535a3.14 3.14 0 0 0-2.689-1.52H4c-2.206 0-4 1.795-4 4v5c0 2.207 1.794 4 4 4h4.965c2.849 0 5.57-1.22 7.466-3.347l6.805-7.638a3.02 3.02 0 0 0-.219-4.23zm-1.274 2.899-6.805 7.638A8.01 8.01 0 0 1 8.965 22H4c-1.103 0-2-.897-2-2v-5c0-1.103.897-2 2-2h8.858c.63 0 1.142.513 1.142 1.143 0 .564-.421 1.05-.981 1.13l-5.161.737a1 1 0 0 0 .283 1.98l5.16-.736a3.16 3.16 0 0 0 2.515-2.06l4.426-4.863a1.01 1.01 0 0 1 1.428-.066c.407.37.44 1.009.073 1.42z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-holding-droplet_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandHoldingDroplet;
